import type { MindItem } from '@kimuno/api-sdk/lib/types/responses/MindItem';
import type { Product } from '@kimuno/api-sdk/lib/types/responses/Product';
import { Box, type Theme, useMediaQuery } from '@mui/material';
import React from 'react';

import { spaces } from '../../assets/styles/themes/tokens';
import useScreenSize from '../../utils/useScreenSize';
import SummaryCoverImage from './SummaryCoverImage';
import SummaryDetails from './SummaryDetails';

const SummaryContent: React.FC<{
	itemData: Partial<Product> | Partial<MindItem>;
	isLoading: boolean;
	primaryHeaderText: string;
	secondaryHeaderText?: string;
	alignDetailsToBottom?: boolean;
}> = ({
	itemData,
	isLoading,
	primaryHeaderText,
	secondaryHeaderText,
	alignDetailsToBottom,
	children,
}) => {
	const { isSmScreen } = useScreenSize();
	const flexDirectionBreakPoint = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: flexDirectionBreakPoint ? 'column' : 'row',
				gap: isSmScreen ? spaces.md : spaces.xl,
			}}
		>
			<SummaryCoverImage
				isNew={itemData.isNew}
				coverImage={itemData.thumbnail}
				isLoading={isLoading}
				title={itemData.title}
			/>
			<SummaryDetails
				itemData={itemData}
				primaryHeaderText={primaryHeaderText}
				secondaryHeaderText={secondaryHeaderText}
				alignToBottom={alignDetailsToBottom}
			>
				{children}
			</SummaryDetails>
		</Box>
	);
};

export default SummaryContent;
